import { useMemo, useRef } from 'react';
import { useStandardization } from '../../screens/StandardizationScreen/context';
import Button from '../Button';
import Dropdown from '../Dropdown';
import ValidationInput from '../ValidationInput';
import ProjectsList from './ProjectsList';
import {
  Input,
  NewProjectDesc,
  NewProjectInputsWrapper,
  NewProjectWrapper,
  ProjectsWrapper,
  StartBtnWrapper,
  Title,
  Wrapper,
} from './styles';
import { useHistory } from 'react-router-dom';
import useClickOutside from '../../hooks/useClickOutside';
import useObjectElements from '../../hooks/useObjectElements';
import useGetStandardizationProjects from './hooks/useGetStandardizationProjects';
import useGetArchivedStandardizationProjects from './hooks/useGetArchivedStandardizationProjects';
import useGetStandardizationProject from './hooks/useGetStandardizationProject';
import useCreateStandardizationProject from './hooks/useCreateStandardizationProject';
import useGetLayoutDiagrams from './hooks/useGetLayoutDiagrams';
import { useUser } from '../../context/user';
import { user_roles } from '../../config/enums';
import ProjectsDropdown from '../ProjectsDropdown';

const newProjectInitValues = {
  projectId: null,
  projectName: '', //standardization project name
  clientName: '',
  layoutDiagramId: null,
  collectionId: null,
};

const inputsValidation = (value) => value.length > 1;

const SideMenuStandardization = () => {
  const history = useHistory();
  const wrapperRef = useRef();
  const { user } = useUser();
  const canEdit = user?.roles.includes(user_roles.stProject) ||
      user?.roles.includes(user_roles.stFraming) ||
      user?.roles.includes(user_roles.stAdmin) ||
      user?.roles.includes(user_roles.admin) ||
      user?.roles.includes(user_roles.castAdmin);
  const isCastAdmin = user?.roles.includes(user_roles.castAdmin);
  const canCreateDelete = user?.roles.includes(user_roles.stAdmin) ||
      user?.roles.includes(user_roles.admin) ||
      user?.roles.includes(user_roles.castAdmin);
  const { isLeftSideMenuOpen, toggleLeftSideMenu, standardizationProject, setSelectedStandardizationProject } =
    useStandardization();
  const { standardizationProjects: projects, isLoading: areProjectsLoading } = useGetStandardizationProjects();
  const { archivedStandardizationProjects, isLoading: areArchivedProjectsLoading } = useGetArchivedStandardizationProjects();
  const { getProject, isLoading: isProjectLoading } = useGetStandardizationProject();
  const { createProject, isLoading: isCreatingProject } = useCreateStandardizationProject();
  const { layouts, isLoading: areLayoutsLoading } = useGetLayoutDiagrams();
  const {
    object: newProjectForm,
    setObjectValue: setNewProjectForm,
    resetObjectToInitValues: resetForm,
  } = useObjectElements({
    initialValues: newProjectInitValues,
  });

  const layoutsToShow = useMemo(
      () =>
          !layouts
              ? []
              : layouts.map((layout) => ({
                value: layout.id,
                label: `${layout.name}`,
              })),
      [layouts]
  );

  const onProjectItemClick = async (selectedProject) => {
    // fetch project
    const project = (
      await getProject(selectedProject.id)
    ).data;
    setSelectedStandardizationProject(project);
    setImmediate(() => toggleLeftSideMenu(false));
  };

  const isCreateProjectFormValid = () => {
    const validations = [
      {
        field: 'projectName',
        validation: (value) => inputsValidation(value),
      },
    ];

    return validations.every((v) => v.validation(newProjectForm[v.field]));
  };

  const onSuccessfullyCreatedProject = (project) => {
    resetForm();
    history.push(`/standardization/project/${project.id}`);
  };

  const handleCreateProject = () => {
    if (!isCreateProjectFormValid()) return;

    const formData = {
      projectId: newProjectForm.projectId,
      name: newProjectForm.projectName,
      layoutDiagramId: newProjectForm.layoutDiagramId,
      collectionId: newProjectForm.collection,
    };
    createProject(formData, {
      onSuccess: onSuccessfullyCreatedProject,
    });
  };

  useClickOutside(wrapperRef, () => toggleLeftSideMenu(false));
  return (
    <Wrapper
      // isOpened={isLeftSideMenuOpen}
      isOpened={true}
      ref={wrapperRef}>
      {/* <MenuIconBtn
        onClick={() => toggleLeftSideMenu()}
        isOpened={isLeftSideMenuOpen}
      /> */}

      <Title>Open existing project standardization assessment</Title>
      <ProjectsWrapper>
        <ProjectsList
          projects={projects}
          archivedProjects={archivedStandardizationProjects}
          isLoading={areProjectsLoading}
          selectedProjectId={standardizationProject?.id}
          onClick={onProjectItemClick}
          canCreateDelete={canCreateDelete}
          isCastAdmin={isCastAdmin}
        />
      </ProjectsWrapper>

      {canCreateDelete && (
        <NewProjectWrapper>
          <Title>Start standardization assessment of new project</Title>
          <NewProjectDesc>
            You can start a standardization project with a reference modulelist created in the catalog:
          </NewProjectDesc>
          <NewProjectInputsWrapper>
            <ProjectsDropdown
              projectId={newProjectForm.projectId}
              setDataFunc={({ projectId }) => setNewProjectForm('projectId', projectId)}
              isOptional
            />
            <ValidationInput
              component={Input}
              containerStyle={{ width: '100%' }}
              placeholder='Sensitivity case name'
              value={newProjectForm.projectName}
              onChange={(e) => setNewProjectForm(e.target.name, e.target.value)}
              name='projectName'
              validation={(name, value) => inputsValidation(value)}
              errorMsg={'Field must contain text longer than 1 char'}
            />
            <Dropdown
              isLoading={areLayoutsLoading}
              options={layoutsToShow}
              value={newProjectForm.layoutDiagramId}
              isOptional={false}
              placeholder='Define MPF size'
              onChange={(newOption) => {
                console.log(newOption);
                setNewProjectForm('layoutDiagramId', newOption.value);
              }}
              isDisabled={false}
            />
            {/*<Dropdown*/}
              {/*options={mockCollectionsOptions}*/}
              {/*value={newProjectForm.collection}*/}
              {/*isOptional={true}*/}
              {/*placeholder='(Optional) Add a module collection'*/}
              {/*onChange={(newOption) => setNewProjectForm('collection', newOption.value)}*/}
              {/*isDisabled={true}*/}
            {/*/>*/}
          </NewProjectInputsWrapper>
          <StartBtnWrapper>
            <Button
              title={isCreatingProject ? 'Creating' : 'Start'}
              wrapperStyle={{
                width: '100%',
              }}
              textStyle={{
                color: 'white',
                fontSize: '1.2rem',
              }}
              onClick={handleCreateProject}
              disabled={isCreatingProject}
            />
          </StartBtnWrapper>
        </NewProjectWrapper>
      )}
    </Wrapper>
  );
};

export default SideMenuStandardization;
